/**
id(value)
Returns `value`.
*/

export default function id(value) { return value; }
